module.exports = __webpack_public_path__ + "img/github-brands.fe01f466.svg";